<template>
	<div class="product-list">
		<template v-if="products.length == 0">
			<p v-if="context == 'appointment'" class="font-weight-thin ml-2" v-translate>No prescription.</p>
			<p v-if="context == 'settings'" class="font-weight-thin ml-2" v-translate>No Substances found.</p>
			<p
				v-if="context == 'new-product'"
				class="font-weight-thin ml-2"
				v-translate
			>No substances selected.</p>
		</template>
		<template v-else>
			<v-list flat>
				<div
					v-infinite-scroll="loadMore"
					infinite-scroll-disabled="loading"
					infinite-scroll-distance="0"
					v-if="infiniteScroll"
				>
					<SubstanceItem
						v-for="product in products"
						:product="product"
						:key="product.product.id"
						@remove-product="removeProduct"
						@edit-posology="editPosology"
						:type="type"
						:context="context"
						:admin="admin"
						:availableProcessing="availableProcessing"
					/>
					<v-row class="mt-2" v-if="loading" no-gutters>
						<v-progress-linear
							:active="loading"
							:indeterminate="loading"
							top
							color="primary"
						></v-progress-linear>
					</v-row>
				</div>
				<SubstanceItem
					v-else
					v-for="product in products"
					:product="product"
					:key="product.product.id"
					@remove-product="removeProduct"
					@edit-posology="editPosology"
					:type="type"
					:context="context"
					:admin="admin"
					:availableProcessing="availableProcessing"
				/>
			</v-list>
		</template>
	</div>
</template>

<script>
import SubstanceItem from "@/components/products/SubstanceItem.vue";
import infiniteScroll from "vue-infinite-scroll";

export default {
	name: "SubstanceList",
	props: [
		"products",
		"type",
		"context",
		"admin",
		"substanceQuantity",
		"infiniteScroll",
		"availableProcessing"
	],
	components: {
		SubstanceItem
	},
	directives: {
		infiniteScroll
	},
	data: () => ({
		loading: false,
		over: false
	}),
	methods: {
		removeProduct(product) {
			this.$emit("remove-product", product);
		},
		editPosology(product) {
			this.$emit("edit-posology", product);
		},
		loadMore() {
			if(!this.over) {
				this.loading = true;
				this.$emit('load-more');
			}
		},
		addSubstances(products) {
			this.loading = false;
			if(products.length == 0) this.over = true;
			for(let i = 0; i < products.length; i++) {
        this.products.push(products[i]);
			}
		}
	}
};
</script>